module.exports = __webpack_public_path__ + "img/icon-dinners-club.c6842777.svg";